import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { AdHocInstructionsGridDTO } from 'src/app/core/Dtos/ad-hoc/instructions-grid-dto';
import { MorayWestInstructionsGridDTO } from 'src/app/core/Dtos/moray-west/instructions-grid-dto';
import { MorayWestInstructionsComponent } from '../grids/moray-west-instructions/moray-west-instructions.component';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { Router } from '@angular/router';
import { MorayWestService } from 'src/app/core/services/moray-west.service';
import { AdHocInstructionsService } from 'src/app/core/services/ad-hoc-instructions.service';
import { BaseComponent } from '../../base-component';
import { Assets } from 'src/app/core/Dtos/assets-enum';
import { TraderInstructionArgs } from '../../dashboards-viewer/trader-instruction-view-args';
import { OktaService } from '@engie-group/ngx-gem-spaas';

@Component({
    selector: 'app-moray-west-dashboard',
    templateUrl: './moray-west-dashboard.component.html',
    styleUrl: './moray-west-dashboard.component.scss',
    standalone: false
})
export class MorayWestDashboardComponent extends BaseComponent {
  @Output() 
  public OnViewInstruction : EventEmitter<TraderInstructionArgs> = new EventEmitter<TraderInstructionArgs>();

  public SearchCurrentAndFuture: string = "ShowActiveAndFutrure";
  public SearchDateFrom: Date = new Date();
  public SearchDateTo: Date = new Date();

  public MorayWestIntructionsData: MorayWestInstructionsGridDTO[] = [];
  public MorayWestAdHocData: AdHocInstructionsGridDTO[] = [];
  public MorayWestLastRefresh: string = "";

  @ViewChild(MorayWestInstructionsComponent)
  _instructionsComponent: MorayWestInstructionsComponent | undefined;

  constructor(
    dateFormatHelper: DateFormatHelperService,
    oktaService: OktaService,
    alertService: AlertsService,
    private _router: Router,
    private _morayWestService: MorayWestService,
    private _adHocService: AdHocInstructionsService) {
    super(oktaService, alertService, dateFormatHelper)
    // Load Moray West InstructionsF
    this.GetInstructions();
    this.SearchDateFrom.setMonth(this.SearchDateFrom.getMonth() - 1);
  }

  public GetInstructions() {
    if (this.SearchCurrentAndFuture == "ShowActiveAndFutrure") {
      this._morayWestService.GetActiveAndFutureInstructions().subscribe(
        resp => {
          this.MorayWestIntructionsData = resp;
          this.MorayWestLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetActiveAndFutureInstructions(Assets.MorayWest).subscribe(
        resp => {
          this.MorayWestAdHocData = resp;
        }
      );
    }
    else {
      this._morayWestService.GetInstructionsByDateRange(this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.MorayWestIntructionsData = resp;
          this.MorayWestLastRefresh = this.DateFormatHelper.GetDisplayDate(new Date());
        });
      this._adHocService.GetInstructionsByDateRange(Assets.MorayWest, this.SearchDateFrom, this.SearchDateTo).subscribe(
        resp => {
          this.MorayWestAdHocData = resp;
        }
      );
    }
  }

  public SetDateTo(target: any) {
    this.SearchDateTo = target.valueAsDate;
  }
  public SetDateFrom(target: any) {
    this.SearchDateFrom = target.valueAsDate;
  }

  public AddNewInstruction() {
    this._router.navigate(["mowwl-new"]);
  }

  public AddNewAdHocInstruction() {
    this._router.navigate(["mowwl/adhoc-new"]);
  }

  public ViewInstruction(instructionId: string | number, isAdHoc:boolean) {
    this.OnViewInstruction?.next(new TraderInstructionArgs(Assets.MorayWest, instructionId, isAdHoc));
  }
}